"use client";

import { useAnalytics } from "@src/utils/analytics";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { useSession } from "@src/hooks/useSession";

export const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  const { trackPageView } = useAnalytics();
  const pathname = usePathname();
  const session = useSession();
  const plataformName = `${process.env.NEXT_PUBLIC_PLATAFORM_NAME}`;

  useEffect(() => {
    if (pathname && !pathname?.startsWith("/settings")) {
      const pageTitle = document.title.replace(`${plataformName} | `, "");
      trackPageView(pageTitle, { solutionshub_id: session.userId });
    }
  }, [pathname]);

  return <>{children}</>;
};
